export enum PsoUserOptionsEnum {
    None,
    Resident,
    Worker,
    Family
}

export enum PsoUserAgreementEnum {
    None,
    Agree,
    DontAgree
}